export default {
  'last-minute': {
    'title': 'Last Minute Discount',
    'description': 'Do you have a last minute opening or a break in your day that you want to fill? Give your clients a deal and encourage them to book.',
    form: {
      'discount': {
        'label-up': 'Last Minute Discount',
        'label-bottom': 'off the service price',
      },
      'hours': {
        'label-up': 'Booking Window',
        'label-bottom': 'Before appointment start time',
      },
    },
    modals: {
      'success': {
        'title': 'Last Minute Discount Enabled',
        'description': 'Congrats! Your Last Minute Discount is live and we\'re sure your clients will appreciate it. <br> <br> Give them a heads up so they know to take advantage.',
      },
      'delete': {
        'title': 'Stop Discount?',
        'description': 'Clients will no longer receive a discount when they book on short notice.',
        'confirm': 'Stop',
      },
      'hint': {
        'title': 'Last Minute Discount',
        'hint': 'Last Minute Discounts allow you to give your clients a break if they book on short notice. <br><br> This is good for everybody. You get to fill last minute openings or gaps in your schedule and your clients get a deal on your amazing services. <br><br> *Please note your Last Minute Discount will only appear in the Booksy client app.',
      },
      'min-lead': {
        'title': 'Heads up!',
        'description': 'Your current Booking Window conflicts with the Last Minute Discount promotion. To offer this promotion, change your Booking Window to 15 minutes.',
        'confirm': 'Got it. Use 15 minutes instead',
      },
      'info': 'Use Last Minute Discounts to help you fill your schedule on short notice. Everybody wins!',
    },
  },

  'happy-hours': {
    title: 'Happy Hours',
    description: 'When business is slow use Happy Hours to encourage client bookings. You choose the discount along with which days and times you\'d like it to apply to.',
    heading: 'Manage Your Happy Hours',
    'stop-all': 'Stop all',
    'day-tile': {
      'select-time': 'Select time and discount',
    },
    'form': {
      'start-at': 'Start At',
      'end-at': 'End At',
      'discount': {
        'label-up': 'Happy hours discount',
        'label-bottom': 'off the service price',
      },
      'apply-to-others': {
        'heading': 'Copy settings and apply to other days',
        'description': 'Want to offer the same Happy Hours on different days of the week? After you click "Start Promotion" you\'ll be able to select your additional days.',
        'modal-title': 'Apply to other days',
      },
    },
    modals: {
      'success': {
        'title': 'Happy Hours Have Begun',
        'description': 'Your clients can now get a discount when they book an appointment during your selected Happy Hours. <br><br> Message your clients to let them know about this deal.',
      },
      'delete': {
        'title': 'Stop Discount?',
        'description': 'Clients will no longer be offered a discount during your Happy Hours.',
        'confirm': 'Stop',
      },
      'confirm': {
        'title': 'Edit Happy Hours?',
        'description': 'Existing Happy Hours settings for selected days will be overwritten (affects {days}). Are you sure you want to continue?',
        'confirm': 'Yes, edit my happy hours',
      },
      'hint': {
        'title': 'Happy Hours',
        'hint': 'Happy Hours are designed to help you increase bookings during days and times when business is slow. <br><br> Say Monday mornings haven\'t been all that popular lately. Set up Happy Hours for clients to receive 20% off if they visit you before noon on that day. They\'ll appreciate the discount and you\'ll be able to turn your down time in extra money. <br><br> *Please note your Happy Hours discount will only appear in the Booksy client app.',
      },
      'info': 'Happy Hours are great way to fill your calendar when business is typically slow. Set your discount, apply it to certain days and times, then spread the word. Soon you\'ll turn that down time into extra money.',
    },
  },

  'peak-hours': {
    title: 'Premium Hours',
    'stop-all': 'Remove Premium Hours',
    heading: 'Manage your Premium Hours',
    description: 'Fill your calendar and earn more by setting higher rates during high-demand times and non-standard workdays. Set the price increase and select the days and times you\'d like it to apply to.',
    modals: {
      'success': {
        'title': 'Premium Hours are now active',
        'description': 'Clients will now be able to see your higher rates for Premium Hours when they select appointments at these times.',
      },
      hint: {
        title: 'Premium Hours',
        hint: 'Set higher prices for busy slots and non-standard workdays to boost earnings when demand is high. This also encourages budget-conscious clients to book quieter times, helping fill your calendar.<br><br>Select specific days and times for premium pricing, then enter the amount you\'d like to charge extra.<br><br>* Please note your Premium Hours pricing will only appear in the Booksy for Customers app.',
      },
      'delete': {
        'title': 'Remove Premium Hours?',
        'description': 'Removing your Premium Hours means clients will no longer be charged a higher rate during these times. You can come back and add Premium Hours again at any time.',
        'confirm': 'Remove Premium Hours',
      },
      'confirm': {
        'title': 'Change Premium Hours?',
        'description': 'Your changes will overwrite your existing Premium Hours settings for the selected days ({days}).',
        'confirm': 'Save changes',
      },
    },
    form: {
      'discount': {
        'label-up': 'Increase price by',
        'label-bottom': 'during these hours',
      },
      'apply-to-others': {
        'heading': 'Copy settings and apply to other days',
        'description': 'Once you save your changes you will be able to select the other days you want to apply these settings to.',
      },
    },
    'day-tile': {
      'select-time': 'Select time and price increase',
    },
    'promo-modal': {
      title: 'Charge more for your most valuable time slots',
      text: 'With Premium Hours, you can charge more for high-demand times and non-standard workdays. Let your most valuable time earn you the most money.',
      confirm: 'Set Premium Hours',
    },
  },

  'flash-sale': {
    'title': 'Flash Sale',
    'description': 'Start a Flash Sale to promote a new service, celebrate a special occasion, or to simply encourage your clients to book.',
    'prepare-message': 'Prepare message',
    'form': {
      'discount': {
        'label-up': 'Flash Sale Discount',
        'label-bottom': 'off the service price',
      },
      'sale-period': 'Sale period',
      'sale-period-options': {
        'today': 'Today only',
        'x-days': '{value} days',
      },
      'booking-dates-heading': 'Booking date(s) to qualify',
      'start-date': 'Start date',
      'end-date': 'End date',
      'end-date-options': {
        'select': 'Select day',
        'any-day': 'Any Day',
      },
    },
    modals: {
      'success': {
        'title': 'Flash Sale Started',
        'description': 'Congrats! Your Flash Sale is live and we\'re sure your clients will appreciate the discount. <br><br> Give them a heads up so they know to take advantage.',
      },
      'delete': {
        'title': 'Stop Discount?',
        'description': 'Clients will no longer receive this Flash Sale discount.',
        'confirm': 'Stop',
      },
      'hint': {
        'title': 'Flash Sale',
        'hint': 'A Flash Sale is a discount or promotion offered for a short period of time. <br><br> The promotion will apply to all clients who book applicable services within the Flash Sale period. You can customize how long your Flash Sale will last, as well as when those bookings need to occur in order for the promotion to apply. <br><br> You get more bookings and your clients get a deal. Everybody wins! <br><br> * Please note the Flash Sale discount will only appear in the Booksy client app.',
      },
      'info': 'Use Flash Sales for special events like Black Friday or whenever you need to encourage customers to make a booking.',
    },
  },

  'import-from-xlsx': {
    'description': 'Download the template, add your client details, and then upload the file to complete your import.',
    'grow': 'Grow Your Client Base',
    'adding-contacts': 'Adding your contacts is the easiest way to build your client list and start enjoying the perks.',
    'upload-file': 'Upload file',
    'tooltip-content': 'If you already have an .XLS or .CSV file with your client\'s details, choose Upload File. If not, download the template, fill it out, and upload it. <br><br> We\'ll send your clients an invitation to start booking their appointments with you on Booksy.',
    'import-file-modal': {
      'primary-header': 'Do you have a file containing your Clients?',
      'yes': 'Yes',
      'yes-content': 'Tap here if you have a file and upload it to Booksy',
      'no': 'No',
      'no-content': 'Tap here if you don’t have a file with your contacts',
      'secondary-header': 'Prepare & upload Client list',
      'left-content': 'Download our template file and fill it out with your Clients details.',
      'right-content': 'Filled out the template? Upload it to Booksy to import your Clients',
      'left-button': 'Download Template',
      'right-button': 'Upload File',
    },
    'qrcode-or-file-import': {
      'onboarding-header': 'Add your contacts and invite them to book with you',
      'qrcode': {
        'header': 'Import contacts using QR code',
        'description': 'Scan the QR code with your phone camera to import contacts conveniently from your mobile phone via the Booksy Biz app.',
      },
      'file': {
        'header': 'Import contacts from a file',
        'description': 'Import your contacts from an existing CSV or XLS file or use a template prepared by us.',
        'button-label': 'Get started',
      },
    },
    'processing': {
      'title': 'Importing your clients',
      'description': 'This may take a few minutes',
    },
    'uploaded': {
      'title': 'File upload completed',
      'content': 'You may now begin importing & inviting clients',
      'button': 'Import & invite clients',
    },
    'uploaded-hidden': {
      'content': 'Publish your profile to start inviting clients',
    },
    'incorrect-file-type': 'Incorrect file type',
    'file-is-too-big': 'File is too big',
  },

  'import-from-contacts': {
    'intro-title': 'Add clients from your contacts first',
    'intro-description': 'Let your clients know that they can now book themselves. Allow Booksy to access your contacts and we\'ll invite them on your behalf.<br><br>When you choose "Select & Import Contacts" we\'ll add contact names, phone numbers, and profile photos to your client database. You\'ll have the option to choose which contacts you\'d like to add.',
    'imported-title': 'All your contacts were imported',
    'imported-description': 'That means if you will add new contacts to your device, they will be automatically appear here and will be ready to invite to Booksy.',
    'allow': 'Select & Import Contacts',
    'add-clients': 'Import & invite clients',
    'import-clients': 'Import clients',
    'search-contacts': 'Search contacts',
    'processing': 'Your clients are being added…',
    'skip': 'Skip',
    'redirect-button': 'Go to calendar',
    'onboarding-redirect-button': 'Start using app',
    'contacts-empty-title': 'Contact list is empty on your device',
    'contacts-empty-content': 'That means if you will add new contacts to your device, they will be automatically appear in here and will be ready to invite to Booksy.',
    'contacts-empty-content-onboarding': 'That means if you will add new contacts to your device, they will be automatically appear in Import & Invite Clients section and will be ready to invite to Booksy.',
    'contacts-search-empty-title': 'No results found',
    'contacts-search-empty-description': 'There are no clients matching your search. Check the spelling and try again!',
    'permission-settings-modal': {
      title: 'Grant permission manually',
      content: 'Since you have chosen not to ask you again about CONTACTS permission, you have to enable it manually in your phone permissions settings. To do this, tap “Enable” to go to your phone settings screen.',
      enable: 'Enable',
      'go-back': 'Go back',
    },
    'select-and-import': 'Select & Import Contacts',
    'tooltip-content': 'Invite clients directly from the Contacts list on yourdevice.<br><br>Click "Select & Import Contacts" and allow Booksy access to your Contacts. We\'ll send your clients an invitation to start booking their appointments with you on Booksy.',
  },

  'message-your-clients': {
    title: 'Text and Email Marketing ',
    description: 'Use Text and Email Marketing to encourage clients to get on your books and to keep them in the loop. Turn on any of the automated messages below, or create your own custom messages.',
    search: 'Search...',
    'blast-active-modal-title': 'Message Activated!',
    'blast-active-modal-content': 'Booksy will send this message automatically to your clients via email or SMS, based on their preferences. You can deactivate the campaign at any time.',
    'blast-active-modal-button': 'got it',
    'image-picker-title': 'Choose Image',
    'your-portfolio': 'Your Portfolio',
    'all-images': 'All Images',
    'image-categories': 'Image Categories',
    'show-all': 'Show: All',
    'message-title': 'Message title',
    'message-body': 'Message body',
    'text-message': 'Text message',
    'more-occasions': 'Special Occasions',
    'one-time-message': 'Real-Time & Custom',
    'add-media': 'Add media',
    'add-header-image': 'Add header image',
    'create-a-message': 'Create a message',
    'add-your-message': 'Add your message title and body copy. Also include a shortened version for text messages',
    'continue': 'continue',
    'select-recipients': 'Select Recipients',
    'confirm-send-modal': {
      title: 'Confirm Send',
      body: 'Booksy will now send this message to {count} client via email or SMS, based on their preferences. | Booksy will now send this message to {count} clients via email or SMS, based on their preferences. | Booksy will now send this message to {count} clients via email or SMS, based on their preferences.',
      'out-of-sms-body-bold': 'You\'ve run out of SMS limit.',
      'out-of-sms-body': 'Your messages will only be delivered via e-mail and push. Please contact us in order to increase the limit.',
      send: 'Send',
      cancel: 'Cancel',
      'contact': 'Contact customer support',
    },
    'confirm-exit-modal': {
      title: 'Are you sure you want to exit?',
      content: 'Your custom message will be deleted permanently and you\'ll no longer have access to it.',
      exit: 'Exit',
      back: 'Go back',
    },
    'blast-sent-modal-title': 'Message Sent!',
    'blast-sent-modal-content': 'Booksy is sending your message now to your client selection',
    'blast-sent-modal-button': 'Ok, Got it',
    'confirm-recipients-modal': {
      title: 'Confirm message recipients',
      'body-one': 'You’ve choosen to send this message to {count} clients.',
      'body-two': '{count} of them have not opted in to receive electronic communication from you. Do you still want to send the message to these people?',
      'agreed-only': 'Send to those that have opted in',
      all: 'Send to all',
    },
    'send-to-all-clients': 'Send to all clients',
    'booksy-will-send': 'Booksy will send this message to all clients',
    'alternate-short-message': 'SMS or push notification',
    'regular-message': 'E-mail content',
    'no-results-found': 'No results found.',
    'check-your-spelling': 'Check your spelling and try again.',
    'activate': 'Activate',
    'activate-modal': {
      title: 'Text and Email Marketing',
      body: 'You are about to enjoy the power of Text and Email Marketing. Before we continue, let\'s verify messages that are enabled for dispatch.',
      confirm: 'Activate Selected',
      cancel: 'Cancel',
    },
    modal: {
      text: 'Get your clients to book more often by automatically sending them a message at the right time. Turn on any (or all) of the automated messages below.',
      'btn-ok': 'Ok, start messaging',
      'btn-cancel': 'I don\'t want to reach my clients',
    },
    'image-drawer-title': 'Choose Background',
    'add-image': 'Add image',
    'message-scheduled': 'Message scheduled',
    'new': {
      'dashboard-title': 'Text and Email Marketing',
      'lifetime-revenue': 'Lifetime revenue from Text and Email Marketing',
      'build-and-maintain': 'Build and maintain customer relationships <br> thanks to automated messages from Booksy.',
      'turn-on': 'Turn on recommended',
      'turned-on': 'Turned on',
      'campaigns-tab': 'Active',
      'queue-tab': 'Upcoming',
      'search-placeholder': 'Search messages',
      'active': 'active',
      'sent-messages': 'sent messages',
      'appointments': 'appointments',
      'profit': 'current month profit',
      'new': 'new',
      'now': 'now',
      'recommended': 'recommended',
      'in': 'in',
      'no-active': 'No active campaigns at the moment',
      'no-active-desc': 'Activate a campaign to stay connected to your clients',
      'queue-empty': 'No upcoming messages',
      'queue-empty-desc': 'Send your clients a message to keep them in the know.',
      'start-campaign': 'Activate campaign',
      'stop-campaign': 'Deactivate',
      'send': 'Send',
      'save': 'Save',
      'edit': 'Edit',
      'e-mail': 'Email',
      'text-message': 'SMS',
      'push-notification': 'Push notification',
      'booksy': 'booksy',
      'campaign-details': 'campaign details',
      'sending-schedule': 'Delivery timeline',
      'sending-time': 'time of day',
      'channels': 'delivery method',
      'message-details': 'message details',
      'sent-to': 'send to',
      'estimated-cost': 'estimated cost',
      'continue': 'continue',
      'edit-message': 'Edit message',
      'menu-text': 'SMS/Push notification',
      'menu-email': 'Email',
      'menu-schedule': 'Delivery timeline',
      'menu-channels': 'Delivery method',
      'reset': 'Reset to original template',
      'test': 'Send test',
      'preview': 'Preview',
      'message-preview': 'Message Preview',
      'send-test': 'Send Test',
      'send-test-content': 'Before you send this message to your clients, send it to yourself. Check spelling & grammar, make sure the information in the message is accurate, and that it looks and sounds like YOU.',
      'phone-label': 'send test sms or push notification to',
      'email-label': 'send to',
      'characters': 'Characters',
      'message-body': 'Message body',
      'message-title': 'Message title',
      'personalize-your-message': 'Personalize your message',
      'choose-image': 'Choose image',
      'upload-image': 'Upload image',
      'all-images': 'All images',
      'image-categories': 'Image categories',
      'your-uploads': 'Your uploads',
      'portfolio': 'Portfolio',
      'select-rule': 'When to send',
      'time-of-day': 'time of day',
      'morning-time': 'Morning (8.00 AM - 12.00 PM)',
      'afternoon-time': 'Afternoon (12.00 PM - 5.00 PM)',
      'evening-time': 'Evening (5.00 PM - 8.00 PM)',
      'sending-date': 'sending date',
      'date': 'date',
      'send-now': 'Send now',
      'schedule-custom-sending': 'Send later',
      'campaign-scheduled': 'Campaign Scheduled',
      'campaign-scheduled-content': 'Booksy will send this message automatically based on your selections. To receive this message, clients need to have agreed to receive messages via the delivery method you chose and contact information on file. <br>If you chose to send SMS, there may be additional fees. Emails and push notifications are FREE. <br><br>You can deactivate the campaign at any time.',
      'blast-activated': 'Campaign scheduled',
      'blast-deactivated': 'Campaign deactivated',
      'unable-to-send-modal-title': 'Your message can\'t be sent to any of the clients you selected',
      'unable-to-send-modal-info': 'There are few things you can check to figure out why. <br><br> - Make sure your client contact information is up to date and complete. We can\'t send an email if there isn\'t an email address on file. <br><br> - Edit your delivery method. Setting up email, SMS, and push notifications makes it more likely that you\'ll reach a client.',
      'unable-to-send-channel': 'None of the selected clients are able to receive your message via the selected channel. Update your recipients details or edit your sending preferences to send your message.',
      'unable-to-send-channel-sms-limit': 'None of the selected clients are able to receive your message via the selected channel. Edit your sending preferences to send your message or contact us in order to increase the limit.',
      'back-to-edit': 'Edit',
      'cancel-sending': 'Cancel',
      'confirm-send': 'Confirm Send',
      'send-message-to': 'Booksy will send this message to',
      'clients': '<strong>{count}</strong> client | <strong>{count}</strong> clients | <strong>{count}</strong> clients',
      'from-selected': 'of <strong>{count}</strong> client | of <strong>{count}</strong> clients | of <strong>{count}</strong> clients',
      'via-email-or-push': 'only via e-mail or push. Please contact Customer Support in order to increase the limit.',
      'recipients-conflict-tooltip': 'We aren\'t able to send this message to some of the clients you selected because they have already reached their limit for marketing messages this month, or are missing an email or phone number. <br><br>You\'ll recive a report with detailed information after sending this message',
      'free-messages-available': 'Free marketing text messages available:',
      'only-free-channels-available': 'only free channels available',
      'only-free-channels': 'only free channels',
      'included-in-package': 'included in your subscription',
      'per-sms': 'per SMS',
      'estimated-sms': 'Estimated no. of SMS:',
      'estimated-push': 'Estimated no. of push notifications:',
      'estimated-email': 'Estimated no. of emails:',
      'out-of-limit': 'you\'ve run out of limit',
      'confirm-send-gdpr': 'Send the message to all clients, even those who have not opted in to receive communication from you',
      'gdpr-sms-warning': 'Some of the selected clients received too many marketing messages from you recently, or have missing e-mail or phone number information. All detailed information about sent messages will be included in the report.',
      'morning': 'Morning',
      'afternoon': 'Afternoon',
      'evening': 'Evening',
      'send-message-checkbox': 'Some of the clients you selcted have not opted in to receiving communication from you. Check the box if you\'d still like to send them this message.',
      'close-to-limit': 'You\'re close to your SMS limit. The number of recipients is limited to those clients who opted in to receive communication from you.',
      'no-app': 'We can\'t send a push notification to this number',
      'update-phone': 'We can\'t send a test SMS to this number',
      'your-phone': 'Your phone number',
      'register-app': 'To send a test push notification, you need to have downloaded the Booksy for Customers app and registered an account with your phone number.',
      'go-to': 'For security, test SMS can only be sent to the phone number associated with this Booksy account. To update the phone number associated with your account, go to Staff Management & Resources. <br><br>To avoid losing the work you\'ve done on this message so far, consider just sending a test email.',
      'ask-your-manager': 'For security, test SMS can only be sent to the phone number associated with this Booksy account. To update the phone number associated with your account, ask your manager to go to Staff Management & Resources. <br><br>To avoid losing the work you\'ve done on this message so far, consider just sending a test email.',
      'maximum-effectiveness': 'Optimized delivery (recommended)',
      'set-up-own': 'Choose your delivery method',
      'trust-us': 'When you choose this option, you\'re handing it over to Booksy to choose the best way to reach your client. We consider the data we have about which communication methods work best for your clients, how they prefer to communicate with you, and what gives you the best chance to get a return on your investment. This means we may choose to send emails, SMS, and/or push notifications. As always, emails and push notifications are FREE. SMS may have an additional cost.',
      'text-messages': 'SMS',
      'sms-hint': 'You have a limited number of free marketing SMS based on your subscription. After you use them all, SMS cost {smsCost} each.',
      'prefer-push': 'Send SMS if push notification isn\'t available',
      'push-free': 'Push notification (free)',
      'email-free': 'Email (free)',
      'maximum-effectiveness-channel': 'Optimized delivery',
      'push': 'Push',
      'email': 'Email',
      'sms': 'Sms',
      'scheduled': 'Scheduled:',
      'estimated-cost-desc': 'Estimated cost:',
      'delete': 'delete',
      'selected-clients': '{count} selected client | {count} selected clients | {count} selected clients',
      'update-push': 'Update your information to send test push message',
      'scheduled-date': 'Scheduled date',
      'customize-next-sending': 'Customize next sending',
      'are-you-sure': 'Are you sure you want to delete this message?',
      'your-custom': 'Your custom message will be deleted permanently and any versions of this message scheduled to go out in the future will be cancelled.',
      'go-back': 'go back',
      'all': 'All',
      'verify-name': 'Verify the name of your message and try again.',
      'you-have-reached': 'You\'ve reached your limit for free marketing SMS. You\'ll still be able to send emails and push notifications, but if you\'d like to be able to continue to send SMS, constact support to increase the limit.',
      'test-message-sent': 'Test message sent',
      'free-marketing': 'Free marketing SMS available: ',
      'only-free': 'only free channels available',
      'to-add-it': 'To add it, go to Staff Management & Resources.',
      'ask-your-manager-to': 'Ask your manager to add it in Staff Management & Resources.',
      'cant-sms': 'We can\'t send the SMS because your phone number is missing.',
      'cant-sms-and push': 'We can\'t send the SMS and push notification because your phone number is missing.',
      'cant-push': 'We can\'t send the push notification because your phone number is missing.',
      'to-avoid': 'To avoid losing the work you\'ve done on this message so far, consider just sending a test email.',
      'to-send-a-push': 'We can\'t send a push notification to your account. To send a test push notification, you need to download and log in to the Booksy Biz app.',
      'placeholder-warining': 'Make sure your message doesn\'t contain any empty placeholder (eg. [ADD DISCOUNT])',
      'stop-code-hint': 'The character counter includes the information that has to be added according to the french law ({stopCode}). Your sent message will be longer.',
      'text-will-be-added': 'The following text will be added at the end of the SMS: ',
      'message-blast-link-warning': 'Remember that messages may only contain Booksy links (e.g. https://your-business.booksy.com). For security reasons, any non Booksy links will be removed from SMS, push notifications and e-mails.',
      'sms-message-body': 'SMS/Push text',
      'email-message-title': 'E-mail title',
      'email-message-body': 'E-mail content',
      'link-copied': 'Link copied to clipboard',
      'your-profile-link': 'Your profile link:',
      'copy': 'Copy',
    },
  },

  boost: {
    'turn-off': 'Deactivate',
    'request-turn-off': 'Request Deactivation',
    'turn-on': 'Activate',
    'suspension-pending': 'Suspension pending',
    'boost-your-profile': 'Boost your profile',
    'btn-title': 'Boost details',
    'btn-second': 'Reports',
    'inactive-title': 'Get a well-deserved Boost',
    'suspend-title': 'Request has been submitted',
    'copy-link': 'Link to your Booksy profile',
    'copy-to-clipboard': 'Copy link',
    'read-more': 'Read more',
    'read-more-how': 'Read more how to prevent charges for your own clients',
    'learn-more': 'Learn more',
    'thank-you': 'Thank you for your help!',
    'thank-you-response': 'Thank you for your response',
    'go-to-help': 'Go to Boost help',
    'start-today': 'Start today',
    'agree-and-start': 'Agree and get started',
    'get-started': 'Get started',
    'suspend-subtitle': 'A member of our Customer Success team will be in touch shortly to finalize your Boost suspension. Until that time you will still be able to use Boost.',
    'suspend-subtitle-email': 'A member of our Support Team will be in touch shortly to finalize your Boost suspension. Until that time you will still be able to use Boost.',
    'blocked-title': 'Boost is blocked',
    'blocked-subtitle': 'We see a lot of unpaid transactions on your account and will need to investigate. If you have questions, please contact our Customer Success Team, otherwise stand by and we\'ll be in touch soon.',
    'blocked-subtitle-email': 'We\'ve noticed some issues with the payment method you have on file for Boost. To continue using Boost, please verify your payment settings are up to date and that your Boost commission fees have been paid.<br/><br/>If you have questions, please contact the Support Team.',
    'update-payment': 'Update Payment Method',
    'not-eligible-title': 'Ready to start using Boost?',
    'not-eligible-subtitle': 'More eyes on your business and less openings on your books. Contact our Support Team to learn how you can start using Boost to increase your visibility.<br><br>You can reach us on Chat or email at {email}.',
    'no-show': 'No-show',
    'no-show-overdue': 'No-show overdue',
    'first-visit': 'First visit of this client',
    'returned': 'Returned client',
    'claim-pending': 'pending',
    'claim-denied': 'declined',
    'claim-overdue': 'overdue',
    'claimed': 'approved',
    'tax': ' + Tax',
    'dashboard': {
      'title': 'Lifetime Boost Profit',
      'tile-1': 'Total Boost Clients',
      'tile-2': 'Total Boost Appointments',
      'tile-3': 'Current Month Profit',
      'tile-4': 'Rating',
      'tile-4-value': '{count} review | {count} reviews',
    },
    'contact-customer-support': 'Contact Customer Support',
    'contact-us': 'Contact Us to activate Boost',
    'submit-modal': {
      'title': 'Request has been submitted',
      'subtitle': 'We\'ve turned off your Boost and your profile will no longer be promoted. If you have upcoming appointments sourced through Boost commission rates will still apply, but you won\'t incur any new charges.',
      'subtitle-pending': 'A member of our Customer Success team will be in touch shortly to finalize your Boost suspension. Until that time you will still be able to use Boost.',
      'subtitle-pending-email': 'A member of our Support Team will be in touch shortly to finalize your Boost suspension. Until that time you will still be able to use Boost.',
      'subtitle-email': 'We\'ve turned off Boost. Your profile will no longer be promoted and you won’t incur charges on any new bookings. If you have upcoming appointments sourced through Boost, commission rates will still apply. Contact our Support Team for more information (info.us@booksy.com).',
    },
    'turn-on-modal': {
      'title': 'How much does it cost?',
      'subtitle': 'When Boost provides a new client, we deduct a one-time fee that’s {count}% of the cost of their first visit. After that, profits are yours—for life!',
      'subtitle-tax': 'When Boost provides a new client, we deduct a one-time fee that’s {count}% + Tax of the cost of their first visit. After that, profits are yours—for life!',
    },
    'boost-slider': {
      'text': 'All your cost of each new client’s first appointment',
      'top-text': 'All it costs you is',
      'bottom-text': 'of each new client’s first appointment',
      'title-1': 'Customers Are Waiting',
      'description-1': 'Get a well-deserved Boost. Attract and keep more clients with our help.',
      'title-2': 'Get 60% more bookings',
      'description-2': 'On average users saw a 60% increase in bookings after six months of using Boost.',
      'title-3': 'Increase Your Visibility',
      'description-3': 'Enable Boost to rank higher in our search results, get more attention, and increase profile views.',
      'title-4': 'Success Stories',
      'description-4': 'Learn more about Boost from the people who\'ve used it.',
      'stand-out': 'Stand out from the crowd',
      'increase-exposure': 'Increase your exposure and get more eyes on your business with Booksy’s Boost service.',
      'get-seen': 'Get seen by more potential clients',
      'put-profile': 'Put your profile front and center when clients search for services.',
      'increase-visibility': 'Increase your visibility',
      'activate-booksy': 'Activate Booksy’s Boost service to give your business a little helping hand.',
      'find-out-more': 'Find out more',
    },
    'boost-tutorial': {
      'header-1': 'Get The Most Out Of Boost',
      'content-1': 'In order to increase your rank in the Booksy search engine, complete these three steps. Greater visibility could result in more bookings.',
      'header-2': 'Boost Promotion',
      'content-2': 'Along with better search results, you can leverage Boost to show off your talent(s) across Booksy galleries, special badges, blogs, newsletters, and more.',
      'header-3': 'Learn More About Boost',
      'content-3': 'Get the details on how Boost works, how you\'ll be promoted, and how you can help us ensure that you aren\'t accidentally charged for clients that you sourced on your own.',
      'header-4': 'Boost Figures',
      'content-4': 'A glimpse into how you\'ve been performing since you activated Boost. Come here to see how many clients you\'ve attracted with Boost, how many bookings they\'ve completed, and how much profit you\'ve generated as a result. You\'ll also see a summary of your total monthly profit.',
      'header-5': 'Detailed Reports',
      'content-5': 'For more details visit Stats & Reports. Under your Marketing reports you\'ll be able to access information about all of your Boost appointments and Boost claims.',
    },
    'boost-help': {
      'search-placeholder': 'Search in Boost Help',
      'claim-clients': {
        'text-1': 'When you get a new client through Boost they will appear in the statistic section. These clients will also be tagged "1ST VISIT"',
        'text-2': ' within your new client list on Boost details.',
        'text-4': 'We do our best to keep it all straight, but you\'re busy and sometimes we can\'t keep up with you. If you see a client attributed to Boost that you acquired via your own marketing efforts, tap the "Claim" button to begin the claims process.',
        'text-5': 'Please note that all claims must be submitted by {boostClaimDeadline} days of the following month to be accepted.',
        'billing-cycles-text': 'Once your claim is confirmed, we\'ll process a refund for any associated commission fees within seven business days. Please note, all claims must be submitted no later than end of day on the {boostClaimDeadline}th day of the following billing cycle to be eligible for a refund. <strong>Your current billing cycle is {startDate} - {endDate}.*</strong>',
        'billing-cycles-info': '* If your billing cycle is the 16th-15th of every month and you were charged a Boost commission for a client that came in for an appointment on the 14th of February, you would have until the end of the day on the 22nd of February to submit the claim.',
        'no-billing-cycles-text': 'Once your claim is confirmed, we\'ll process a refund for any associated commission fees within seven business days. Please note that all claims must be submitted by {boostClaimDeadline} days of the following month to be accepted.',
      },
      'pricing': {
        'commission-text': 'Commission on each New Client\'s first visit',
        'text-1': 'One commission. One time. And the new client is yours to keep.<br/><br/>The Boost commission fee is {commission}% of the base service value of the client\'s first visit. For one free consultation and other free services there\'s a flat rate of {unpricedFee}.<br/>The maximum commission fee is {maxFee}. You\'ll never pay more than that for a new Boost client. The minimum commission fee is {minFee}. If the calculated commission fee is lower than this minimum, you will be charged this minimum fee of {minFee}.',
        'text-1-tax': 'One commission. One time. And the new client is yours to keep.<br/><br/>The Boost commission fee is {commission}% + Tax of the base service value of the client\'s first visit. For one free consultation and other free services there\'s a flat rate of {unpricedFee} + Tax.<br/>The maximum commission fee is {maxFee} + Tax. You\'ll never pay more than that for a new Boost client. The minimum commission fee is {minFee} + Tax. If the calculated commission fee is lower than this minimum, you will be charged this minimum fee of {minFee} + Tax.',
        'text-2': 'If a new client\'s first visit contains any Add-on Services, Booksy temporarily won\'t charge any commission on the value of the Add-on Service. You\'ll only be charged the commission on the value of the main services. It\'s a deal!<br/><br/>Any changes to the status of the appointment must be done within the same business day in order for us to calculate the correct commission rate. For example, if a client doesn\'t show up for their appointment, change the status to No-Show before the end of the day. This includes changes to the services you provided, no-shows, and cancellations. Otherwise, your commission rate will be calculated from the base value of the services in the original appointment.',
      },
      'how-it-work': {
        'text-1': 'Boost helps you achieve a higher ranking within the Booksy search engine. The greater your exposure the more potential for new bookings.',
      },
      'identifying-new-clients': {
        'text-1': 'Let\'s review what we consider to be a new Boost client.<br/><br/>New Boost clients are brand new to your customer base. This means they don\'t have a booking history with you and/or they\'ve never been manually added to your Booksy customer list.<br/><br/>We\'ll do everything that we can to get new clients on your books, but remember you can still source your own customers using:<br/>• Your personal Booksy link<br/> • Your unique Booksy widget installed on your website, Facebook page, or Instagram.<br/><br/>When you get new clients through these channels, no commission fee applies!',
      },
      'prevent-accidental-charges': {
        'text-0': 'We do our best to see that you\'re only being charged for clients we find you through Boost, but you\'re busy and sometimes we can\'t keep up with you. Here are some ways that you can help us prevent accidental commission charges.',
        'text-1-header': 'Add walk-ins to your client list',
        'text-1': 'If you see a new walk-in client be sure to add their contact information to your Booksy contact list before they leave your shop.',
        'text-2-header': 'Share your Booksy profile link',
        'text-2': 'Include your unique link on your website and business cards to help separate existing clients from new clients who find you through Boost.',
        'text-3-header': 'Double check Instagram',
        'text-3': 'Make sure that your Instagram Book button is routing to your personal Booksy link.',
        'text-4-header': 'Double check Facebook',
        'text-4': 'Make sure that your Facebook Book Now button is routing to your personal Booksy link.',
      },
    },
    'conditionals': {
      'title': 'Get Noticed',
      'most-out-of-boost': 'Get the most out of Boost',
      'congratulations-activated': 'Congratulations! You\'ve activated Boost and completed all three steps.',
      'missing-out': 'You may be missing out on new opportunities! To enjoy the full benefit of Booksy\'s Boost service be sure to complete all three steps to give your profile the biggest boost.',
      'hint-description': 'Get people talking! Positive feedback from loyal clients is one of the best marketing tools you have.<br/><br/>Tips for generating more reviews:<br/>Ask your clients to submit a review right when their appointment ends so that they don\'t forget. Send messages to your regular clients encouraging them to share their experience.',
      'active': 'Active',
      'inactive': 'Inactive',
      'setup-incomplete': 'Setup incomplete',
      'active-subtitle': 'Congratulations! You\'ve activated Boost and completed all three steps. New clients will be able to discover you even easier now you have increased visibility.',
      'inactive-subtitle': 'You\'ve turned on Boost, now let\'s make sure you\'re getting the most out of it. Complete all three steps to get 100% of the benefit.',
      'setup-incomplete-subtitle': 'You\'re not using Boost to its fullest potential and may be missing out on new opportunities. Complete all three steps to get 100% of the benefit and put your profile front and center when clients search for your services.',
      'boost-incomplete-badge': 'Almost complete',
      'boost-inactive-badge': 'Want more boost?',
      'boost-active-badge': 'Champion of Boost',

    },
    'conditional-tile': {
      'title-1': 'Add a cover photo',
      'subtitle-1': 'Add a photo that represents your brand and your business',
      'title-2': 'Add 3+ photos of your work',
      'subtitle-2': 'Show off your skills',
      'title-3': '+5 reviews, +4.5 ★ rating',
      'subtitle-3': 'It’s time to bring in more reviews!',
      'completed': 'Completed',
    },
    'dashboard-tile': {
      'title-1': 'Selected Period Profit',
      'title-2': 'Lifetime Boost Profit',
    },
    'clients': {
      'new-clients': {
        'tab': 'New clients',
        'text': 'Tap claim button to report accidental Boost charges',
        'tap-to-request': 'Tap claim button to request a claim',
      },
      'returning': {
        'text': 'All the profits from those clients are yours!',
        'tab': 'Returning',
      },
      'claimed': 'Claimed',
      'no-new-clients-title': 'Boost clients haven\'t visited this time period',
      'no-new-clients-description': 'Continue to upload photos to your profile and encourage client reviews to increase your rank within our search engine.',
      'no-returning-clients': 'No returning clients for this time period',
      'no-returning-clients-title': 'No returning clients for this time period',
      'no-claimed-clients': 'No claimed Boost clients for this time period',
      'no-claimed-clients-title': 'No claimed Boost clients for this time period',
      'empty-state-title': 'Haven\'t received any Boost clients',
      'empty-state-description': 'There\'s still more you can do. Continue to upload photos to your profile and encourage client reviews to increase your rank within our search engine.',
    },
    'client-tile': {
      'no-show': 'No-show',
      'revenue': 'Profit',
      'cost': 'Cost',
      'claim': 'Claim',
      'no-show-overdue': 'No-show overdue',
    },
    'not-allowed-modal': {
      'title': 'You\'ve started the claim process',
      'text': 'In the next step, you\'ll be asked how the client found you so that we can verify your claim. If it\'s approved, the commission fee will be refunded.<br/><br/>Visit Boost Help for more information on how to avoid accidental charges.',
    },
    'claim-confirm-modal': {
      'title': 'Client Claimed',
      'text-claimed': 'Visit Boost Help to review how you can avoid accidental charges in the future.',
      'title-pending': 'Claim Submitted',
      'text-pending': 'If your claim is accepted, the commission fee will be refunded. Visit Boost Help to learn how to prevent accidental Boost charges.',
      'claim-overdue-month': 'We appreciate you sharing this information so that we can continue to improve Boost. As a reminder, claims must be submitted no later than the end of day on the {boostClaimDeadline}th day of the following month to be eligible for a refund.<br/><br/> To learn more about the claims process visit our Get Help section.',
      'claim-overdue-billing-cycle': 'We appreciate you sharing this information so that we can continue to improve Boost. As a reminder, claims must be submitted no later than the end of day on the {boostClaimDeadline}th day of the following billing cycle to be eligible for a refund.<br/><br/> To learn more about the claims process visit our Get Help section.',
      'to-learn-more': 'To learn more about the claims process visit our Get Help section.',
      'claim-request-sent': 'Claim request sent',
      'boost-comission-fee': 'The Boost commission fee will be refunded if your claim is accepted.',
      'learn-more-boost': 'To learn more about Boost charges visit Boost Help.',
      'done': 'Done',
      'go-to-boost-help': 'Go to Boost Help',
      'account-notice': 'Account notice',
      'large-number-of-claims': 'We\'ve noticed a large number of claims from your account.',
      'many-invalid-claims': 'Submission of many invalid claims may result in a suspension of Boost service.',
      'visit-boost-help': 'To learn more about Boost charges and what claims are considered valid visit Boost Help.',
      'claim-could-not-be-completed': 'Claim could not be completed',
      'claim-must-be-submitted': 'Claims must be submitted on or before the <b>{boostClaimDeadline}th day of the following billing cycle</b> - as stated in the Boost Terms & Conditions.',
      'learn-more-about-claims': 'To learn more about the claims process you can visit our Boost Help.',
    },
    'claim-overdue-modal': {
      'text': 'We appreciate you sharing this information so that we can continue to improve Boost. As a reminder, claims must be submitted within {count} days of the client visit to be eligible for a refund.<br/><br/> To learn more about the claims process visit our Get Help section.',
    },
    'sidebar-part': {
      'title-1': 'Identifying New Clients',
      'description-1': 'New Boost clients are those that don\'t have a booking history with you and/or they\'ve never been manually added to your Booksy client list.<br/><br/>With Boost we help you to get discovered by increasing your visibility but remember you can still promote your page using:<br/>- Your personal Booksy link<br/>- Your unique Booksy widget installed on your website, Facebook page, or Instagram.<br/><br/>When new clients book with you through these channels, there is no Boost commission fee!',
      'title-2': 'Get Promoted',
      'description-2': 'Not getting the attention you want? Let us promote you. Leveraging our search engine, galleries, special badges, ads, blog, and newsletters we\'ll help you show off your talent(s) to potential customers.<br/><br/>You get to focus on doing what you love and enjoy the bookings that come as a result.',
      'title-5': 'Time to celebrate',
      'description-5': 'One fee. One time. That\'s all you\'ll be charged for each client that Booksy sends you through Boost. If you\'ve turned a Boost customer into repeat business, celebrate because 100% of that revenue lands in your pocket.',
      'title-6': 'Keep it up',
      'description-6': 'Let us promote you and see what else is possible with Boost. Leveraging our search engine, galleries, special badges, ads, blog, and newsletters we\'ll help you show off your talent(s) to potential customers. <br/><br/> You get to focus on doing what you love and enjoy the bookings that come as a result.',
      'title-7': 'Claims overview',
      'description-7': 'Once your claim is confirmed we\'ll process a refund for any associated commission fees within seven business days.',
      'description-7-age': 'Once your claim is confirmed we\'ll process a refund for any associated commission fees within seven business days. Please note that all claims must be submitted within {count} days to be eligible for a refund.',
      'description-7-deadline': 'Once your claim is confirmed we\'ll process a refund for any associated commission fees within seven business days. Please note that all claims must be submitted by {count} day of the following month to be accepted.',
      'title-8': 'Avoiding accidental charges',
      'description-8': 'We do our best to see that you\'re only being charged for clients we find you through Boost, but you\'re busy and sometimes we can\'t keep up with you. Here are some ways that you can help us prevent accidental commission charges<br/><br/>• Add walk-ins to your client list<br/>• Share your personal Booksy link<br/>• Proper Facebook setup<br/>• Proper Instagram setup',
      'title-no-show': 'No-show',
      'description-no-show': 'If a client doesn\'t show up for their appointment, change the status to No-Show before the end of the day.',
      'your-boost-guide-title': 'Your Boost guide',
      'your-boost-guide-description': 'New to Boost or want to improve your results? Discover all the details and best practices in our dedicated Boost guide.',
      'submit-a-claim-title': 'Need to submit a claim?',
      'submit-a-claim-description': 'If you believe that a commission was charged in violation of the Boost Terms & Conditions, tap the “Claim” button to begin the claim process. Please note that all claims must be submitted by 7th day of the following billing cycle to be accepted.',
    },
    'boost-review': {
      'description': 'Boost is a great way to attract clients and fill up your schedule, especially for barbers just getting started.',
    },
    'activate-boost-modal': {
      'title': 'Congrats on activating Boost',
      'text': 'Now let\'s got you set up so that you can start attracting more clients today.',
      'terms-info': 'By activating Boost, you agree to the <a href="{boostTermsUrl}"><strong>Boost Terms & Conditions</strong></a>.',
      'new-terms-info': 'The Boost Terms and Conditions are <a href="{boostTermsUrl}"><strong>here</strong></a>. By clicking "Get started" below, you confirm that you have read and accept that they apply to your Boost service.',
    },
    'churn-poll-modal': {
      'title': 'Your Opinion Matters',
      'description': 'You\'ll be missed! Let us know why you\'re leaving so that we can make improvements.',
    },
    'claim-poll-modal': {
      'title': 'Claim your client',
      'description': 'Is this one of your existing clients? If so let us know how they found you. This information will help us improve Boost accuracy.',
      'send-claim': 'Send claim',
      'claim-description': 'Make a claim if you believe that you were charged a Boost commission for this client against Terms and Conditions.',
      'claim-reason': 'Select reason for claim',
      'confirm-all-infromation': 'I confirm that all information provided is true. I am aware that claims without a valid reason will be rejected.',
      'add-information': 'Add as much information as possible',
      'tell-us-more': 'Tell us more',
      'provide-details': 'Please provide details of your claim',
      'add-details': 'You must add details',
      'something-went-wrong': 'Something went wrong, please try again',
      'add-images-title': 'Adding images helps us to speed up the claim process',
      'add-images': 'Add images',
      'attachment': 'Attachment',
      'attachment-tooltip': 'You may add up to {imagesCount} images. File must be {size} MB or less. Accepted file types are .jpg, .jpeg, .png or .gif.',
      'file-too-large': 'File is too large',
      'resolution-warning': 'Accepted resolution of the file must be {resolution} x {resolution} pixels or less.',
      'images-count-warning': 'You may upload up to {imagesCount} images. If you wish to upload a new image, please remove one of the existing images.',
      'size-warning': 'File must be {size} MB or less. Accepted file types are .jpg, .jpeg, .png or .gif.',
    },
    'social-share-modal': {
      'title': 'Share Profile',
      'profile-link': {
        'title': 'Profile Link',
        'description': 'Copy your Profile Link and share it on your social media pages, in text messages and directly with your customers when they ask for a booking link.',
        'description-2': 'Share your profile link on your social media, via text or direct message to allow clients to book with you directly.',
      },
    },
    'social-share-icons': {
      'share-on': 'Share on',
    },
    'qr-code-share': {
      'title': 'Profile QR Code',
      'description': 'Download your QR code and post it in your front window, on marketing materials, even on your business card.',
      'download-qr-code': 'Download',
      'tooltip-title': 'What\'s a QR Code?',
      'tooltip-description': 'QR codes help people quickly and easily find your Booksy Profile. All they need is the camera on their mobile device.',
    },
    'turn-off-modal': {
      'title': 'Suspend Boost?',
      'text': 'When you disable Boost your profile will still appear on Booksy but we will no longer promote your business listing. This could translate to fewer customers coming through your door.',
      'text-2': 'When you disable Boost your profile will still appear on Booksy but we will no longer promote your business listing. This could translate to fewer customers coming through your door.<br/><br/>What you\'ve achieved with Boost to date:',
      'btn-1-text': 'Suspend Boost',
      'btn-2-text': 'Go Back',
      'turn-off': 'Deactivate',
      'request-turn-off': 'Request Deactivation',
    },
    'summary-table': {
      'text-1': 'Lifetime Boost Profit',
      'text-2': 'Completed Appts',
      'text-3': 'Boost clients',
      'text-4': 'Upcoming Boost Appts',
    },
    'status': {
      'active': 'Active',
      'blocked': 'Blocked',
      'deactivated': 'Deactivated',
      'disabled': 'Disabled',
      'inactive': 'Inactive',
      'not-eligible': 'Not eligible',
      'suspension-pending': 'Suspension pending',
    },
    'waiver-of-withdrawal': {
      'short': 'I agree that the services will start to be provided before the deadline for withdrawal from the distance contract.',
      'full': ' I agree that the services will start to be provided before the deadline for withdrawal from the distance contract. I understand that the service will commence immediately and in the event I choose to withdraw from the contract, I agree to pay for the services provided up until the moment of withdrawal. I acknowledge and agree that I will lose the right to withdraw from the service after completion.',
      'error': 'Check this agreement to get started',
      'error-toast': 'Check the agreement to activate Boost',
    },
    'boost-ban': {
      'tile-info': 'Boost suspended until {activeTill} due to a violation of T&C’s.',
      'less-visibility-info': 'Until Boost is reactivated, your profile will no longer be promoted in search results, resulting in a lower visibility for your business. Reduced visibility may lead to fewer new client bookings.',
      'suspension': {
        'title': 'Access to Boost suspended',
        'first-paragraph': 'Your account has been temporarily suspended from accessing the Boost service for <strong>30 days</strong> until <strong>{activeTill}</strong> due to a violation of the <a href="{termsUrl}" target="_blank"><strong>Boost Terms & Conditions</strong></a>, specifically related to actions that lead to the avoidance or lowering of Boost commissions. After this period, Boost will be automatically reactivated.',
      },
      'suspension-with-invoice': {
        'title': 'Access to Boost suspended',
        'first-paragraph': 'Your account has been temporarily suspended from accessing the Boost service for <strong>30</strong> days until <strong>{activeTill}</strong> due to a violation of the <a href="{termsUrl}" target="_blank"><strong>Boost Terms & Conditions</strong></a>, specifically related to actions that lead to the avoidance or lowering of Boost commissions.',
        'second-paragraph': 'Within 15 business days you will receive an invoice for unpaid Boost fees. Once received, you have 7 days to complete payment. Payment is required to reactivate Boost.',
      },
      'termination': {
        'title': 'Boost service terminated',
        'first-paragraph': 'Your Booksy Boost service was terminated with immediate effect due to a violation of the <a href="{termsUrl}" target="_blank"><strong>Boost Terms & Conditions</strong></a>, specifically related to actions that lead to the avoidance or lowering of Boost commissions.<br><br>You will be able to reactivate Boost after <strong>{activeTill}</strong>. Until then, your access to the Boost service will remain suspended.',
      },
      'termination-with-invoice': {
        'title': 'Boost service terminated',
        'first-paragraph': 'Your Booksy Boost service was terminated with immediate effect due to a violation of the <a href="{termsUrl}" target="_blank"><strong>Boost Terms & Conditions</strong></a>, specifically related to actions that lead to the avoidance or lowering of Boost commissions.<br><br>You will be able to reactivate Boost after <strong>{activeTill}</strong>. Until then, your access to the Boost service will remain suspended.',
        'second-paragraph': 'Within 15 business days you will receive an invoice for the unpaid Boost fees. Once received, you have 7 days to complete payment. Payment is required to reactivate Boost.',
      },
    },
    'violation-warning-modal': {
      'terms': 'Boost Terms & Conditions',
    },
    'how-it-works-drawer': {
      'title': 'How it works',
      'paragraph-1': 'Boost is a Booksy marketing tool designed to increase your business’s exposure to more clients near you. Activating Boost enhances your visibility on our Marketplace and in the Booksy for Customers app.',
      'paragraph-2': 'The commission is {commission} of the total price of services performed during the first completed appointment of a new client.',
      'paragraph-3': 'The minimum commission is {minFee}. It will be charged even if the commission percentage would be lower. The maximum commission amount is {maxFee} — you will never pay more.',
      'paragraph-4': 'A fixed commission of {unpricedFee} applies to free services, such as consultation.',
      'paragraph-5': 'Remember that the commission is calculated only on the first completed appointment of a Boost client — 100% of the revenue from future appointments of this client belongs to you!',
      'tax': ' + Tax',
    },
  },

  shared: {
    'promotion-tile': {
      'clients-not-invited': 'clients not invited',
      'not-invited': 'Not invited',
      'invited': 'Invited',
      'inactive': 'Inactive',
      'running': 'Running',
      'active': 'Active',
      'activation-pending': 'Activation pending',
      'suspension-pending': 'Suspension pending',
      'blocked': 'Blocked',
      'trial': 'Trial',
      'waiting-list': 'Waiting List',
      'shared': 'Shared',
      'activated-on': 'Activated on',
      'deactivated-on': 'Deactivated on',
      'disabled-on': 'Disabled on',
      'clients-invited': 'Clients invited',
      'last-post-shared': 'Last post shared',
      'last-message': 'Last message',
      'active-offers': 'Active Offers',
      'appointments': 'Appointments',
      'revenue': 'Revenue',
      'profit': 'Profit',
      'no-access': 'No access',
      'year-to-date-profit': 'Year to date profit',
      'year-to-date-bookings': 'Year to date bookings',
      'remaining': 'Remaining',
    },
    'form': {
      'services': {
        'title': 'Apply to Services',
        'all': 'Applied to all services',
        'selected': 'Applied for selected services ({count})',
      },
      'start-promotion': 'Start promotion',
    },
    'modals': {
      'success': {
        'send-message': 'Send the message',
        'skip-message': 'Skip the message',
        'share-on-social-media': 'Share on social media',
      },
      'no-access': {
        'title': 'Restricted access',
        'description': 'You don\'t have the appropriate permissions to access {name}. Please check with your Manager.',
        'button': 'Got it',
      },
    },
    status: {
      'inactive': 'Inactive',
      'active': 'Active',
      'running': 'Running',
    },
    'blast-send-cost': {
      'automatic': {
        'free': 'Available in your package',
        'cost': 'Additional cost',
        'sms': 'SMS',
        'over': 'for each SMS over the limit',
      },
      'manual': {
        'send-to': 'Send message to',
        'clients': '{count} client | {count} clients | {count} clients',
        'via': '({sms} via SMS, {email} via email)',
        'to-be-sent': 'SMS to be sent',
        'sms-per-clients': '{count} client x {sms} SMS | {count} clients x {sms} SMS | {count} clients x {sms} SMS',
        'estimated-cost': 'Estimated cost',
        'included': '(included in your package)',
        'sms-price': '({price} for SMS)',
        'via-emial-push': '(via e-mail or push)',
      },
    },
  },

  'import-invite': {
    'invite-again': {
      description: 'See below for a status of your existing invites. Reinvite clients who didn\'t take any steps to get on your books after your last message.',
      invited: 'Client invited',
      'client-not-invited': 'Client has already been invited.',
      'publish-profile': 'Publish your profile to start inviting clients',
    },
    'quick-invite': {
      label: 'Quick invite',
      description: 'Type in the phone number or email address for the person you want to invite. We\'ll send them an invite on your behalf. The invite will show them how to join Booksy and start booking appointments with you through the app.',
      note: 'Note: ',
      'note-content': 'When you send a Quick Invite, the recipients are not added to your Client list.',
      send: 'Send invite',
      'input-label': 'Phone number or email address',
      'modal-title': 'Update Your Online Booking Settings First',
      'modal-text': 'You can\'t send invites to users while Online Bookings are turned off. To turn on Online Booking, go to Settings>Online Booking and then switch the toggle to ENABLED.',
      'modal-text-button': 'Go to Online Booking Settings',
      'publish-profile-label-one': 'You can\'t send invites to users while Online Bookings are turned off. To turn on Online Booking, go to ',
      'booking-tools': 'Online Booking',
      'publish-profile-label-two': ' in Settings and Enable Online Bookings.',
      'sent': `Invite sent to {recipient}`,
    },
    'import': {
      'title': '{success} out of {all} clients have been imported and invited to use Booksy.',
      'description': 'Check your inbox to see the report and be on the lookout for bookings.',
      'button-label': 'Got it',
      'unimported-title': 'None of your clients have been imported',
      'unimported-description': 'To import clients successfully please prepare the file with the correct clients data. Check your inbox to see the report.',
    },
  },

  'invite-customers': {
    modal: {
      title: 'Import & Invite Clients',
      text: 'Stop getting interrupted by calls and texts from clients! Invite them to book online 24/7 through Booksy.',
      'btn-ok': 'Start inviting',
      'btn-cancel': 'I like being interrupted',
    },
  },
  'special-offers': {
    modal: {
      title: 'Promotions',
      text: 'Want to fill empty seats? Ready to generate more business? Sure you do! We added features to your profile to help with those exact goals. Let\'s get started.',
      'btn-ok': 'Ok, set up promotions',
      'btn-cancel': 'I don\'t want to fill empty seats',
    },
  },
  'marketing-banner': {
    modal: {
      title: 'Marketing Banner',
      text: 'Use your Marketing Banner to communicate important updates directly from your Booksy profile page. Highlight new services, current promotions, and more.',
      'btn-ok': 'Create banner message',
      'btn-cancel': 'No, thanks',
    },
  },
  'social-post-creator': {
    modal: {
      title: 'Social Media Marketing',
      text: 'Sharing is caring. Show off your work by sharing your portfolio photos on social media.',
      'btn-ok': 'Share now',
      'btn-cancel': 'I don\'t want to share my work',
    },
    'logo-modal': {
      header: 'Upload logo first',
      body: 'It seems your business doesn\'t have its\' logo uploaded yet. Upload the logo first to add it to your post.',
      confirm: 'Upload logo',
      cancel: 'Cancel',
    },
    'main-menu': {
      'add-logo': 'Add logo',
      'remove': 'Remove logo',
      'format': 'Format',
      'text': 'Text',
      'background': 'Background',
    },
    hashtags: {
      placeholder: 'E.g. #vip #favourite',
    },
    'social-post-title': 'Social Media Marketing',
    'creator-title': 'Share Post',
    'change-template': 'Change template',
    'content-box-title': 'Turn your followers into customers',
    'content-box-text': 'Use our Social Media Marketing feature to build your online presence and drive client bookings.',
    'share-drawer-title': 'Share post',
    'share-drawer-desc': 'Before sharing, you can optionally choose from proposed hashtags or type in your own that you like to add to your post. After choosing where to share your post, hashtags will be copied to your clipboard.',
    'share-drawer-text': 'Choose how to share your Post',
    'format-editor': {
      square: 'Square',
      stories: 'Stories',
      back: 'Back',
    },
    'backgrounds-drawer': {
      'choose-photo': 'Choose photo',
      'photos-attached': 'Photos attached to the review',
      'other': 'Others',
    },
    'reviews-drawer': {
      'choose-review': 'Choose Review',
      'placeholder-title': 'Oops! No reviews here...',
      'placeholder-description': 'You are yet to receive your first 5 star review.<br> Only then you will be able to share it!',
    },
    'choose-background': 'Choose background',
    'categories-header': 'Choose post category',
    'or-select-from-templates': 'Or select from templates',
    'create-text-modal': {
      'header': 'Create your own text',
      'button': 'Save and continue',
      'label': 'Input text',
    },
    'texts': {
      'header': 'Choose template',
      'create-own': 'Create your own text',
    },
    'initial-modal': {
      'header': 'Social Media Share',
      'content': 'Sharing is caring. Show off your work by sharing your portfolio photos on social media.',
      'confirm': 'Share Now',
      'cancel': 'I don\'t want to share my work',
    },
    'buttons-tutorial': {
      'crop-content': 'Adjust your post to suit your needs. Square images look great in your feed, while rectangular ones work well for stories.',
      'text-content': 'Start typing to add text to your post. Keep it simple to grab your customers\' attention as they scroll.',
      'logo-content': 'Once you add your logo, you can drag and drop it anywhere on your post. Just make sure your Booksy Profile link is still visible. <br><br>You can also remove your logo at any time by tapping "Remove Logo".',
      'background-content': 'Choose a background image for your post. Select a photo from your Portfolio or browse our image library.',
    },
    'logo-tutorial': {
      content: 'You can drag and drop to place your logo anywhere on your post. Be careful not to place it on your message or subdomain address, though! You can remove your logo by tapping “Remove logo” in the options bar.',
    },
    'textframe-placeholder': 'Start typing...',
  },
  'gdpr-warning': 'Pay attention if selected customers agreed to receive communication regarding your services',
  'try-ttp': {
    modal: {
      title: 'Tap To Pay available now',
      admin: {
        description: 'With Tap to Pay you can easily accept in-person, contactless payments, right on your phone.',
        description2: 'No extra terminals or hardware needed. Always with you, ready and connected.',
        promo: 'Get started now to simplify payments for you and your clients.',
      },
      employee: {
        description: 'Letting you kno w about our Tap To Pay feature that allows you to accept contactless payments for appointments via your phone.',
        promo: 'To get started ask the account owner.',
        alert: 'Tap To Pay may only be enabled as a payment method by those with Owner or Manager permission level.',
      },
      'get-started': 'Tell me more',
      cancel: 'Not now',
      ok: 'Done',
    },
    'modal-with-badge': {
      badge: 'Simple payments',
      title: 'Tap To Pay available now',
      'first-paragraph': {
        promo: 'Try the easiest way to get paid.',
        description: 'Accept in-person, contactless payments, right on your phone. No extra terminals or hardware needed.',
      },
      'second-paragraph': {
        promo: 'One tap is all it takes.',
        description: 'Activate Tap To Pay and get paid in one tap when checking out a client on Booksy Biz app.',
      },
      buttons: {
        cancel: 'Not now',
        ok: 'Tell me more',
      },
    },
  },
  'try-blik': {
    'blik-for-zero': {
      badge: 'SPECIAL OFFER',
      title: 'Prepayments with BLIK for 0zł!',
      'first-paragraph': {
        promo: 'Protect your business from no-shows',
      },
      'second-paragraph': {
        description: 'Enable prepayments for your services. When a client selects BLIK code as the prepayment method, we won’t charge a commission fee, and you will receive the full amount. The offer is time-limited.',
        additional: 'See special offer rules',
      },
      buttons: {
        cancel: 'Not now',
        ok: 'Tell me more',
      },
    },
  },
  'ttp-reminder': {
    badge: {
      days: '{count} day left|{count} days left',
      hours: '{count} hour left|{count} hours left',
    },
    title: `You're ready to go! Try Tap to Pay on iPhone for free now.`,
    description: `There's only {count} day left to enjoy your first three Tap to Pay transactions with no processing fees.|There's only {count} days left to enjoy your first three Tap to Pay transactions with no processing fees.`,
    'description-2': `Just select Tap to Pay as the payment method during checkout to get paid in one tap.`,
    buttons: {
      'ok': 'Try it now',
      'cancel': 'Remind me later',
    },
  },
  'suspension-subscription-fake-door': {
    button: 'Pause',
    splash: {
      title: 'Subscription pause is not available yet',
      text: 'Thank you for your interest. Subscription pause isn’t available just yet but our team is taking notes so we can keep improving Booksy for you!',
    },
  },
  'google-business-profile': {
    'tile': {
      'make-bookings': 'More bookings from Google?',
      'make-sure': 'Make sure clients can easily find and book you.',
      'check-now': 'Check now',
    },
    'sign-in-with-google': {
      'header-title': 'Google Business Profile',
      'title': 'Get bookings from Google Search and Maps',
      'subtitle': 'Make sure you\'re connected or get set up so clients can book you through Google.',
      'note': 'It\'s <strong>quick and easy</strong> – we\'ll walk you through it.',
      'cancel': 'Cancel',
      'btn-label': 'Sign in with Google',
    },
    'select-account': {
      'title': 'Select your Google account',
    },
    'cancel-modal': {
      'title': 'Leave setup now?',
      'subtitle': 'Your connection with Google isn\'t finished yet. If you leave, any progress will be lost.',
      'continue': 'Continue setup',
      'leave': 'Leave now',
    },
    'locations': {
      'title': 'Match your Google location with Booksy',
      'add-location-info-one': 'Doesn\'t look right?',
      'add-location-info-many': 'You can add more locations later.',
      'add-location': 'Add location',
      'confirm-location': 'Continue with selected location',
    },
    'no-location': {
      'title': 'Add your business to Google',
      'description': 'We\'ll help you set up a Google Business Profile using your Booksy business details.',
      'check-now': 'Create Google Business Profile',
    },
    'add-location': {
      'title': 'Use details from Booksy to add location to Google?',
      'fields': {
        'name': 'Name',
        'address': 'Address',
        'business-category': 'Business Category',
      },
      'add-btn-label': 'Add location',
    },
    'verify-profile': {
      'title': 'Verify your Google Profile',
      'info': {
        'title': 'Google verification in 3 simple steps',
        'step-1': 'We’ll take you to Google.',
        'step-2': 'Complete verification with Google.',
        'step-3': 'You’ll get an email with the result within 5 business days.',
      },
      'buttons': {
        'preview': 'Preview your Google account',
        'done': 'Done',
        'not-now': 'Not now',
        'verify': 'Verify your Google Profile',
      },
      'status': {
        'pending': {
          'title': 'Waiting for Google verification',
          'description': 'Verification takes up to 5 business days. You\'ll receive an email from Google with the result.',
        },
        'failed': {
          'title': 'Your Google Profile could not be connected',
          'description': 'This might be due to an issue with Google or failed verification. Please try again.',
        },
        'completed': {
          'title': 'Your Booksy profile is connected to Google',
          'description': 'Clients can now easily find you and book your services directly from Google Search and Maps.',
        },
      },
    },
    'update-location': {
      'title': 'Update Google location?',
      'subtitle': 'Your business details need to match to successfully connect your accounts.',
      'update-google': 'Update Google location',
      'update-booksy': 'Update in Booksy instead',
    },
    'verification-process': {
      'verify-title': 'Verify your Google Profile',
      'code-title': 'Enter your verification code',
      'select-method': 'Choose a verification method',
      'send-code': 'We\'ll send a verification code to:',
      'call-code': 'You\'ll receive an automated call at:',
      'sms': 'Text message',
      'email': 'Email',
      'phone-call': 'Phone call',
      'verify-now': 'Verify now',
      'continue': 'Continue',
      'enter-code': 'Sent to:',
      'resend-code': 'Resend code',
      'change-method': 'Change verification method',
      'invalid-code': 'Invalid code. Please try again.',
      'provided-to': 'Provided to:',
    },
  },
  'visibility-promotion': {
    'inactive-tile': {
      title: 'Promote your profile your way',
      subtitle: 'Get more exposure on Booksy with full control over your budget.',
      button: 'View plans',
      'learn-more': 'Learn more',
      new: 'New',
    },
    slider: {
      'slide-1': {
        title: 'Promote your profile your way',
        text: 'Get increased exposure in the Booksy marketplace with a time-bound promotion you control.',
      },
      'slide-2': {
        title: 'One flat fee. Full control.',
        text: 'You\'ll only pay for the time you\'re actively promoted—a time-bound promotion that gives you full control over your budget.',
      },
      'slide-3': {
        title: 'Get seen by more clients nearby',
        text: 'More visibility in the Booksy for Customers app puts your profile in front of local clients.',
      },
      'slide-4': {
        title: 'Turn searches into bookings',
        text: 'Attract new clients and turn them into regulars with services they\'ll love.',
      },
    },
    'offer-modal': {
      'choose-period': 'Choose your promotion period',
      'continue-button': 'Continue to payment',
    },
    'offer-tile': {
      day: 'day',
      tax: '+ VAT',
    },
    'purchase-modal': {
      title: 'Complete payment',
      subtitle: 'Profile promotion',
      'offer-name': '{offer} plan',
      taxes: 'Taxes',
      total: 'Total',
      'payment-method': 'Payment method',
      'pay-button': 'Pay',
      'footer-note': 'Your payment may take up to 24 hours to process.',
      'terms-text-1': 'By clicking "Pay {price}" below, you confirm that you have read the <a href="{termsUrl}" target="_blank"><strong>Terms of Service</strong></a> for the Profile Promotion service and agree that they apply to the service you are using.',
      'terms-text-2': 'I agree to the service starting immediately, before the end of the withdrawal period for a distance contract.',
      'terms-text-2-long': 'I agree to the service starting immediately, before the end of the withdrawal period for a distance contract.<br><br>I understand that if I withdraw from the contract, I will be charged for the service used up to that point. I also understand that I will lose my right to withdraw once the service is complete.',
      'show-more': 'Show more',
      'show-less': 'Show less',
    },
    'feedback-modal': {
      title: 'Help us understand',
      text: 'Your feedback helps us make Booksy even better for you. We\'d love to know why you decided to pass for now.',
      'option-1': 'I\'m just browsing',
      'option-2': 'I don\'t need promotion right now',
      'option-3': 'The price is too high',
      'option-4': 'I don\'t understand the benefits',
      'option-5': 'Other',
      'input-placeholder': 'Please specify.',
      'submit-button': 'Submit feedback',
      'skip-button': 'Skip',
    },
    'appreciation-modal': {
      title: 'Thank you for your feedback!',
      text: 'We appreciate you sharing your thoughts—it helps us make Booksy better for everyone.<br><br>In the meantime, you can still promote your profile with Boost.',
      'proceed-button': 'Promote with Boost',
    },
    'payment-status-modal': {
      'in-progress': {
        title: 'Activating your plan...',
      },
      success: {
        title: 'Your plan is now active!',
      },
      error: {
        title: 'There was a problem activating your promotion',
      },
    },
    dashboard: {
      'learn-more': 'Learn more',
      'stats-subtitle': 'Results are updated every 24 hours.',
      'data-calculation-title': 'How are these results calculated?',
      'data-calculation-text': 'We compare the views, clicks, and appointments you received during the promotion period to the same number of days before it began.',
      'stats-legend': 'Promotion period',
    },
    'switch-from-boost': {
      title: 'Switch from Boost to Profile Promotion',
      text: 'You currently have Boost active. To continue with Profile Promotion, Boost will be deactivated. We’ll handle the switch right after you confirm your payment. Profile Promotion will take over seamlessly and keep your business highlighted.',
      consent: 'I agree to deactivate Boost in order to enable Profile Promotion. I understand that I might still be charged for Boost appointments that were created before it was disabled. Reactivating Boost in the future might be subject to new terms & conditions.',
      continue: 'Continue',
      cancel: 'Cancel',
    },
  },
  'platform-fee': {
    'modal': {
      'title': 'Keep every dollar you earn with Platform Fees',
      'intro': 'You can now choose to pass payment fees onto your clients, so you keep every dollar you earn. Pick your model:',
      'outro': 'By default, nothing changes - you’ll keep paying the full fee as you do today. Clients will see the Platform Fee listed on their receipt.',
      'points': {
        'you-client-pay': 'Pass full fee onto your client (You keep 100%)',
        'split-the-payment': 'Split the fee with your client (You pay only 1%)',
        'pay-yourself': 'Keep covering the full fee yourself',
      },
      'buttons': {
        'set-up-platform-fee': 'Set up Platform fee',
        'ask-me-later': 'Ask me later',
      },
    },
  },
}
